/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getOidcToken } from '../../env-vars';
import AuthService from '../../services/AuthService';
import { setUser } from '../../store/shared/userSlice';
import useSessionCheck from './useSessionCheck';

interface IProps {
  render: () => React.ReactNode;
}

export default function SessionCheck({ render }: IProps) {
  const authService = new AuthService();
  const [loadChildren, setLoadChildren] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const userSession = localStorage.getItem(getOidcToken());
  const { ignoreSessionCheck } = useSessionCheck();
  const shouldIgnoreSessionCheck = ignoreSessionCheck();

  useEffect(() => {
    if (shouldIgnoreSessionCheck) {
      setLoadChildren(true);
      return;
    }

    if (userSession) {
      authService.getUser().then((res) => {
        const currentTimeUtc = Math.floor(new Date().getTime() / 1000);
        if (res) {
          if (currentTimeUtc >= res.expires_at) {
            authService.logout();
            return;
          }
          dispatch(setUser({ ...res }));
          setLoadChildren(true);
        } else {
          authService.logout();
        }
      });
    } else {
      authService.login(location.pathname + location.search);
    }
  }, [
    location.pathname,
    location.search,
    shouldIgnoreSessionCheck,
    userSession,
  ]);

  if (!loadChildren) {
    return null;
  }

  return <>{render()}</>;
}
